// The two identifiers every wrapping and envelope is bound to: the member id
// the API scopes rows by, and the keyId naming the MK generation (a UUID v4,
// which the API validates on every envelope). Checked once here so a caller
// bug fails locally with a clear message instead of as a 400 after the
// plaintext has already been sealed.

/** UUID v4, the shape the API's `@IsUUID('4')` accepts for `kid`. */
export const KEY_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * @param {unknown} memberId
 * @returns {asserts memberId is number}
 */
export function assertMemberId(memberId) {
  if (!Number.isInteger(memberId) || memberId <= 0) {
    throw new TypeError('memberId must be a positive integer');
  }
}

/**
 * @param {unknown} keyId
 * @returns {asserts keyId is string}
 */
export function assertKeyId(keyId) {
  if (typeof keyId !== 'string' || !KEY_ID_PATTERN.test(keyId)) {
    throw new TypeError('keyId must be a UUID v4');
  }
}
